import axios from '../axios/axios';
import {
  AGENT_QUESTIONNAIRE_DATA_REQUEST,
  AGENT_QUESTIONNAIRE_DATA_SUCCESS,
  AGENT_QUESTIONNAIRE_DATA_FAIL,
} from '../constants/agentConstant';

export const agentAction = () => async (dispatch) => {
  try {
    dispatch({ type: AGENT_QUESTIONNAIRE_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s26',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: AGENT_QUESTIONNAIRE_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: AGENT_QUESTIONNAIRE_DATA_FAIL,
      payload: error,
    });
  }
};
